import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/about-bg.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-03dbdcf7")

_pushScopeId("data-v-03dbdcf7")
const _hoisted_1 = { class: "about-banner" }
const _hoisted_2 = {
  key: 0,
  class: "slogan"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("简单向上")
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "/", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("努力工作")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "/", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("与人为善")
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "/", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("遵守承诺")
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_11 = { class: "container" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h3", null, "关于我们", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "content" }, [
  /*#__PURE__*/_createVNode("p", null, " 蒲公英孵化器成立于2014年，是依托于顺融资本设立的投资驱动型孵化器。通过近八年多孵化器运营管理的探索和经验积累，围绕企业发展不同阶段的需求提供完善的创业服务体系，同时依托于母公司顺融资本十多年专业的股权投资经验，采用“创业载体+创业服务+创业投资”三驾马车驱动的新型创业服务模式，致力于帮助创业者一站式解决创业困难。 "),
  /*#__PURE__*/_createVNode("p", null, " 运营至今，凭借扎实的运营服务能力，蒲公英先后荣获第一批国家级科技企业孵化器、全国最受欢迎孵化器TOP10、中国十佳孵化器、中国最佳创业服务、江苏省特色众创空间10强等多个行业殊荣。 ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { style: {"width":"100%","height":"100%"} }, [
  /*#__PURE__*/_createVNode("video", {
    style: {"width":"100%","height":"100%"},
    muted: "",
    autoplay: "",
    src: "http://pic.pgyspace.com/group1/M00/00/2E/rBMAAWKgONeAF4DjAjAh_StpZmA821.mp4",
    controls: "controls"
  })
], -1)
const _hoisted_15 = {
  class: "yeji",
  id: "yeji"
}
const _hoisted_16 = { class: "container" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "yeji-item-box" }, "孵化业绩", -1)
const _hoisted_18 = { class: "yeji-item-box" }
const _hoisted_19 = { class: "item flexRow" }
const _hoisted_20 = { class: "number" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "danwei" }, [
  /*#__PURE__*/_createVNode("span", null, "+")
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("p", null, "每年孵化创业项目", -1)
const _hoisted_23 = { class: "yeji-item-box" }
const _hoisted_24 = { class: "item flexRow" }
const _hoisted_25 = { class: "number" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "danwei" }, [
  /*#__PURE__*/_createVNode("span", null, "+")
], -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("p", null, "每年培育人才项目", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "yeji-item-box" }, [
  /*#__PURE__*/_createVNode("div", { class: "item flexRow" }, [
    /*#__PURE__*/_createVNode("div", { class: "number lgnumber" }, [
      /*#__PURE__*/_createVNode("div", null, "150000")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "danwei" }, [
      /*#__PURE__*/_createVNode("span", null, "方")
    ])
  ]),
  /*#__PURE__*/_createVNode("p", null, "累计孵化面积超")
], -1)
const _hoisted_29 = { class: "yeji-item-box" }
const _hoisted_30 = { class: "item flexRow" }
const _hoisted_31 = { class: "number" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "danwei" }, [
  /*#__PURE__*/_createVNode("span", null, "+亿元")
], -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("p", null, "基金规模", -1)
const _hoisted_34 = { class: "yeji-item-box" }
const _hoisted_35 = { class: "item flexRow" }
const _hoisted_36 = { class: "number lgnumber" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "danwei" }, [
  /*#__PURE__*/_createVNode("span", null, "+家")
], -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("p", null, "已培育上市公司", -1)
const _hoisted_39 = { class: "story container" }
const _hoisted_40 = { class: "story-title" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 大事记 ")
const _hoisted_42 = {
  class: "story-content flexRow",
  ref: "story"
}
const _hoisted_43 = { class: "story-left" }
const _hoisted_44 = { class: "story-right" }
const _hoisted_45 = { class: "list flexRow" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createBlock("div", {
    class: "about",
    onScroll: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollGet($event)))
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.device === 'desktop')
        ? (_openBlock(), _createBlock("h2", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      _hoisted_10
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_el_row, {
        class: "about-us news-wrapper flexRow",
        id: "about",
        gutter: 20
      }, {
        default: _withId(() => [
          _createVNode(_component_el_col, {
            class: "about-us-left",
            md: 12,
            sm: 12,
            xs: 24
          }, {
            default: _withId(() => [
              _hoisted_12,
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            class: "about-us-left",
            md: 12,
            sm: 12,
            xs: 24
          }, {
            default: _withId(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_el_row, {
          class: "news-wrapper flexRow",
          gutter: 20
        }, {
          default: _withId(() => [
            _createVNode(_component_el_col, {
              class: "yeji-item",
              md: 8,
              sm: 12,
              xs: 24
            }, {
              default: _withId(() => [
                _hoisted_17
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "yeji-item",
              md: 8,
              sm: 12,
              xs: 24
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.globaNumberName), { value: 500 }))
                    ]),
                    _hoisted_21
                  ]),
                  _hoisted_22
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "yeji-item",
              md: 8,
              sm: 12,
              xs: 24
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.globaNumberName), { value: 30 }))
                    ]),
                    _hoisted_26
                  ]),
                  _hoisted_27
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "yeji-item",
              md: 8,
              sm: 12,
              xs: 24
            }, {
              default: _withId(() => [
                _hoisted_28
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "yeji-item",
              md: 8,
              sm: 12,
              xs: 24
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.globaNumberName), { value: 20 }))
                    ]),
                    _hoisted_32
                  ]),
                  _hoisted_33
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "yeji-item",
              md: 8,
              sm: 12,
              xs: 24
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_34, [
                  _createVNode("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.globaNumberName), { value: 10 }))
                    ]),
                    _hoisted_37
                  ]),
                  _hoisted_38
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_39, [
      _createVNode("div", _hoisted_40, [
        _hoisted_41,
        _createVNode("div", _hoisted_42, [
          _createVNode("div", _hoisted_43, [
            _createVNode("div", {
              class: [[_ctx.isFixed ? 'isFixed' : ''], "story-menu"]
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.yearsList, (item, index) => {
                return (_openBlock(), _createBlock("a", {
                  href: '#d' + _ctx.active,
                  class: ["item", [_ctx.active === index ? 'active' : '']],
                  key: index,
                  onClick: ($event: any) => (_ctx.changeActive(index))
                }, _toDisplayString(item), 11, ["href", "onClick"]))
              }), 128))
            ], 2)
          ]),
          _createVNode("div", _hoisted_44, [
            _createVNode(_component_el_timeline, null, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.memorableList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                    placement: "top",
                    key: index
                  }, {
                    default: _withId(() => [
                      _createVNode("div", {
                        class: "story-item",
                        id: 'd' + index
                      }, [
                        _createVNode("p", {
                          innerHTML: _ctx.formatValue(item.description)
                        }, null, 8, ["innerHTML"]),
                        _createVNode("div", _hoisted_45, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.image.split(','), (k, i) => {
                            return (_openBlock(), _createBlock("img", {
                              src: k,
                              alt: "",
                              key: i
                            }, null, 8, ["src"]))
                          }), 128))
                        ])
                      ], 8, ["id"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ], 512)
      ])
    ])
  ], 32))
})